import Moment from "moment";
import { VatService } from "../../classes/VatService";
/**
 * Removes the standard rate of VAT from a figure.
 *
 * @param amount
 * @param date
 * @param vatRate
 */
export function unvatify(amount, date = null, vatRate = 'S') {
    date = date ? Moment(date) : Moment();
    let v = new VatService(date);
    return v.unvatify(amount, vatRate);
}
